import axios from '../Utils/axios'

const STORE_FARMING_ENDPOINT = '/store-farming'

export async function getScenarios() {
  const resp = await axios.get(`${STORE_FARMING_ENDPOINT}/scenarios`)

  // error handling
  if (!resp.data) {
    throw resp
  }

  return { data: resp.data }
}

export async function getTemplateMessages() {
  const resp = await axios.get(`${STORE_FARMING_ENDPOINT}/template_messages`)

  // error handling
  if (!resp.data) {
    throw resp
  }

  return { data: resp.data }
}
export async function getMessageParams(campaignAudienceId?: number) {
  const resp = await axios.get(
    `${STORE_FARMING_ENDPOINT}/template_messages/parameter${
      campaignAudienceId ? `?audience_segment_id=${campaignAudienceId}` : ''
    }`
  )

  // error handling
  if (!resp.data) {
    throw resp
  }

  return { data: resp.data }
}

export async function getActions() {
  const resp = await axios.get(`${STORE_FARMING_ENDPOINT}/actions`)

  // error handling
  if (!resp.data) {
    throw resp
  }

  return { data: resp.data }
}

export async function getActionDetail(id) {
  const resp = await axios.get(`${STORE_FARMING_ENDPOINT}/actions/${id}`)

  // error handling
  if (!resp.data) {
    throw resp
  }

  return { data: resp.data }
}
